import { useGlobalInterval } from './useGlobalInterval';

export const GlobalInterval = () => {
  useGlobalInterval();
  return null;
};
